import React from 'react';
import { Box, Flex, Text } from '@cko/primitives';
import styled from 'styled-components';

import { Notification } from '../../../../types';
import { getFormattedDate } from '../../../../utils/formatDate';
import { ReadStatusButton } from '../ReadStatusButton';

const ITEM_VIEW_TEST_ID = 'notifications-in-navigation-item-view';

type WrapperProps = {
  onClick?: () => void;
};
const Wrapper = styled(Flex)<WrapperProps>`
  border-radius: var(--border-r-stamp);
  justify-content: space-between;
  padding: var(--layout-spoon);
  transition: background-color 100ms;
  transition-timing-function: var(--easing-accelerate);

  &:hover {
    background-color: var(--control-bg-decorative-hover);
    ${({ onClick }) => onClick && `cursor: pointer;`}
  }
`;

const DotBox = styled(Box)`
  color: var(--base-text-secondary);
  margin: 0 var(--layout-soybean);
`;

type Props = {
  notification: Notification;
  onClick?: () => void;
};

export const ItemView = ({ notification, onClick }: Props) => {
  const {
    dashboardAction,
    clientName,
    createdTimestamp,
    entityName,
    eventId,
    message,
    notificationType,
    isRead,
    title,
  } = notification;

  const formattedDate = getFormattedDate(new Date(createdTimestamp));
  const accountNameToDisplay = entityName || clientName;

  return (
    <Wrapper data-testid={ITEM_VIEW_TEST_ID} onClick={onClick}>
      <Box>
        <Box marginBottom="var(--layout-seed)">
          <Text font="var(--body-xs-emphasis)">{title}</Text>
        </Box>
        <Box marginBottom="var(--layout-seed)">
          <Text>{message}</Text>
        </Box>
        <Flex>
          {accountNameToDisplay && (
            <>
              <Text color="var(--base-text-secondary)" font="var(--body-xs-medium)">
                {accountNameToDisplay}
              </Text>
              <DotBox as="span">⦁</DotBox>
            </>
          )}
          <Text color="var(--base-text-secondary)" font="var(--body-xs-medium)">
            {formattedDate}
          </Text>
        </Flex>
      </Box>
      <Box>
        <ReadStatusButton
          dashboardActionType={dashboardAction.type}
          isRead={isRead}
          notificationId={eventId}
          notificationType={notificationType}
        />
      </Box>
    </Wrapper>
  );
};
